import Style from './index.module.less'
import classNames from 'classnames'

const BlockTitle = ({ title = '标题', needIcon = true }: { title: string; needIcon?: boolean }) => {
  return (
    <div
      className={classNames({
        [Style.wrap]: true,
        [Style.wrapNoromal]: !needIcon,
      })}
    >
      {title}
    </div>
  )
}

export default BlockTitle
